module.exports = "<!-- RIBBON -->\r\n<div id=\"ribbon\">\r\n    <sa-route-breadcrumbs></sa-route-breadcrumbs>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/ribbon/ribbon.component.html
// module id = ./src/app/shared/layout/ribbon/ribbon.component.html
// module chunks = main